import { TranscriptEntry } from '../../../platform-call';

// small, but important
export function createFilteredQuotesLookup(
    quotes: TranscriptEntry[],
    selectedQuotes: TranscriptEntry[],
): { lookup: { [index: number]: boolean }; all: boolean } {
    const lookup =
        quotes?.map((e) => {
            return selectedQuotes == null ? false : selectedQuotes.includes(e);
        }) ?? {};
    const all =
        quotes != null && selectedQuotes != null
            ? quotes?.length === selectedQuotes?.length
            : false;
    return { lookup, all };
}
